module.exports = __webpack_public_path__ + "static/media/5011.b9c76285.jpg";